import { useState } from "react";

interface UserAvatarProps {
  displayName?: string;
  avatarUrl?: string;
}

export function userInitials(displayName?: string): string {
  const normalized = displayName?.trim();
  if (!normalized) return "我";
  const words = normalized.split(/\s+/).filter(Boolean);
  if (words.length > 1) {
    return words.slice(0, 2).map((word) => word[0]?.toUpperCase()).join("");
  }
  return [...normalized].slice(0, 2).join("").toUpperCase();
}

export function UserAvatar({ displayName, avatarUrl }: UserAvatarProps) {
  const [failedUrl, setFailedUrl] = useState<string>();
  const resolvedName = displayName?.trim() || "当前用户";
  const showImage = Boolean(avatarUrl && failedUrl !== avatarUrl);

  return (
    <span className="user-avatar" aria-label={`${resolvedName}的头像`} title={resolvedName}>
      {showImage
        ? <img
          src={avatarUrl}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setFailedUrl(avatarUrl)}
        />
        : <span aria-hidden="true">{userInitials(resolvedName)}</span>}
    </span>
  );
}
